import React from 'react'
import type { CardProps } from '@vtex/admin-ui'
import { Card, csx, cx } from '@vtex/admin-ui'

export type IndicatorCardContainerProps = CardProps

export const IndicatorCardContainer = ({
  className = '',
  ...props
}: IndicatorCardContainerProps) => (
  <Card
    className={cx(
      csx({
        padding: '$space-7',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 64,
      }),
      className
    )}
    {...props}
  />
)
